<template>
  <div id="">
    <restored-fields-modal/>
    <nav class="row">
      <!-- <div class="">
        <div class=""> -->

      <div class="bar-icons">
        <div class="iconsall">

          <div @mouseout="tooltipReturnList = false" @mouseover="tooltipReturnList = true" class="icons-individual">
            <button id="iconReturnList" class="btn btn-default mybutton" @click="goToList" tabindex="-1">
              <!-- Return To Form List -->
              <i class="fas fa-list"></i>
            </button>
            <tooltip-icons v-if="tooltipReturnList == true"
              :descriptionIcons="descriptionReturnList"
              :left="leftIconReturnList"
            />
          </div>
          <div id="iconShowHide" @mouseout="tooltipShowHide = false" @mouseover="tooltipShowHide = true" class="icons-individual dropdown">
            <button class="btn btn-default mybutton dropdown-toggle" type="button" id="dropdownMenuShowHide" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="far fa-eye"></i></button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuShowHide">
              <a class="dropdown-item" href="#" v-on:click="toggleAssignIndexes">
                <span v-if="$store.state.assigningIndexes"><i class="fas fa-eye-slash"></i> Hide Tab Indexes </span>
                <span v-else><i class="fas fa-eye"></i> Show Tab Indexes </span>
              </a>
              <a class="dropdown-item" href="#" @click="toggleShowFields">
                <span v-if="$store.state.showFields"><i class="far fa-eye-slash"></i> Hide Inputs</span>
                <span v-else><i class="fas fa-eye"></i> Show Inputs</span>
              </a>
            </div>
          </div>
          <tooltip-icons v-if="tooltipShowHide == true"
            :descriptionIcons="descriptionShowHide"
            :left="leftIconShowHide"
          />

          <div @mouseout="tooltipDragIndex = false" @mouseover="tooltipDragIndex = true" class="icons-individual">
            <button id="iconDisableDragIndex" v-if="$store.state.dragIndex" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" tabindex="-1" @click="toggleDragIndex">
              <i class="fas fa-toggle-on"></i>
            </button>
            <button id="iconEnableDragIndex" v-else class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" tabindex="-1" @click="toggleDragIndex">
              <i class="fas fa-toggle-off"></i>
            </button>
          </div>
          <tooltip-icons v-if="tooltipDragIndex == true"
            :descriptionIcons="descriptionDragIndex"
            :left="leftIconDragIndex"
          />
          <div class="icons-individual">
              <button @mouseout="tooltipResetTabIndexes = false" @mouseover="tooltipResetTabIndexes = true" id="iconResetTabIndexes" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" tabindex="-1" @click="resetIndexes">
                <i class="fas fa-undo"></i>
                <!-- Reset Tab Indexes -->
              </button>
              <tooltip-icons v-if="tooltipResetTabIndexes == true"
                :descriptionIcons="descriptionResetTabIndexes"
                :left="leftIconResetTabIndexes"
              />
              
          </div>
          <div class="icons-individual">
              <button @mouseout="tooltipCreateField = false" @mouseover="tooltipCreateField = true" id="iconCreateField" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" tabindex="-1" @click="addField">
                <i class="fas fa-plus"></i>
                <!-- Create Field -->
              </button>
              <tooltip-icons v-if="tooltipCreateField == true"
                :descriptionIcons="descriptionCreateField"
                :left="leftIconCreateField"
              />
              
          </div>
          <div class="icons-individual">
              <button @mouseout="tooltipSaveTemplate = false" @mouseover="tooltipSaveTemplate = true" id="iconSaveTemplate" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" tabindex="-1" @click="saveData">
                <i class="far fa-save"></i>
                <!-- Save Template Data -->
              </button>
              <tooltip-icons v-if="tooltipSaveTemplate == true"
                :descriptionIcons="descriptionSaveTemplate"
                :left="leftIconSaveTemplate"
              />
              
          </div>
          <div @mouseout="tooltipMultipleSelect = false" @mouseover="tooltipMultipleSelect = true" class="icons-individual">
              <button id="iconDisableMS" v-if="$store.state.multipleSelect" class="btn btn-default mybutton backgroundIcon" :disabled="$store.state.currentTemplateName === 'global'" tabindex="-1" @click="multipleSelect">
                <i class="fas fa-list-ol"></i>
              </button>
              <button id="iconEnableMS" v-else class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" tabindex="-1" @click="multipleSelect">
                <i class="fas fa-list-ol"></i>
              </button>
              
          </div>
          <tooltip-icons v-if="tooltipMultipleSelect == true"
            :descriptionIcons="descriptionMultipleSelect"
            :left="leftIconMultipleSelect"
          />
          <div class="icons-individual">
              <button @mouseout="tooltipImportModels = false" @mouseover="tooltipImportModels = true" id="iconImportModels" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" tabindex="-1" @click="importModels">
                <i class="fas fa-file-import"></i>
                <!-- Import Models -->
              </button>
              <tooltip-icons v-if="tooltipImportModels == true"
                :descriptionIcons="descriptionImportModels"
                :left="leftIconImportModels"
              />
              
          </div>
          <div class="icons-individual">
              <button @mouseout="tooltipImportAllTranslations = false" @mouseover="tooltipImportAllTranslations = true" id="iconImportAllTranslations" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" tabindex="-1" @click="importAllTranslationModel">
                <i class="fas fa-language"></i>
                <!-- Import All Translations From Model -->
              </button>
              <tooltip-icons v-if="tooltipImportAllTranslations == true"
                :descriptionIcons="descriptionImportAllTranslations"
                :left="leftIconImportAllTranslations"
              />
          </div>
          <div class="icons-individual">
              <button @mouseout="tooltipRestoreFields = false" @mouseover="tooltipRestoreFields = true" id="iconRestoreFields" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" tabindex="-1" @click="restoreFieldsDataJson">
                <i class="fas fa-window-restore"></i>
                <!-- Restore Fields -->
              </button>
              <tooltip-icons v-if="tooltipRestoreFields == true"
                :descriptionIcons="descriptionRestoreFields"
                :left="leftIconRestoreFields"
              />
              
          </div>
          <div @mouseout="tooltipHighlighter = false" @mouseover="tooltipHighlighter = true" id="iconHighlighter" class="icons-individual dropdown">
              <button class="btn btn-default mybutton dropdown-toggle" type="button" id="dropdownMenuHighLight" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-highlighter"></i></button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuHighLight">
                  <a class="dropdown-item" href="#" @click="toggleModelDisplay">
                    <span v-if="modelDisplay"><i class="fas fa-highlighter colorIcon01"></i> Disable Model</span>
                    <span v-else><i class="fas fa-highlighter colorIcon01"></i> Enable Model</span>
                  </a>
                  <a class="dropdown-item" href="#" @click="toggleIdDisplay">
                    <span v-if="idDisplay"><i class="fas fa-highlighter colorIcon02"></i> Disable Id Field </span>
                    <span v-else><i class="fas fa-highlighter colorIcon02"></i> Enable Id Field </span>
                  </a>
              </div>
          </div>
          <tooltip-icons v-if="tooltipHighlighter == true"
            :descriptionIcons="descriptionHighlighter"
            :left="leftIconHighlighter"
          />

          <div class="icons-individual">
              <button
                @mouseout="tooltipBarcodeTemplate = false"
                @mouseover="tooltipBarcodeTemplate = true"
                id="iconBarcodeTemplate"
                class="btn btn-default mybutton"
                :disabled="$store.state.currentTemplateName === 'global'"
                tabindex="-1"
                @click="isBarcode = true"
              >
                <i class="fas fa-barcode"></i>
                <!-- Barcode template -->
              </button>
              <tooltip-icons v-if="tooltipBarcodeTemplate == true"
                :descriptionIcons="descriptionBarcodeTemplate"
                :left="leftIconBarcodeTemplate"
              />
              
          </div>

          <div class="icons-individual">
              <button
                @mouseout="tooltipMergeData = false"
                @mouseover="tooltipMergeData = true"
                id="iconMergeData"
                class="btn btn-default mybutton"
                :disabled="$store.state.currentTemplateName === 'global'"
                tabindex="-1"
                @click="mergeFieldsData"
              >
                <i class="fas fa-object-ungroup"></i>
                <!-- Merge Data -->
              </button>
              <tooltip-icons v-if="tooltipMergeData == true"
                :descriptionIcons="descriptionMergeData"
                :left="leftIconMergeData"
              />
              
          </div>

          
          <!-- <p class="navbar-brand" href="#" tabindex="-1">
            <img id="primaLogo" src="static/mainlogo.png">
            <span>Form Builder</span>
          </p> -->

          <div @mouseout="tooltipZoom = false" @mouseover="tooltipZoom = true" id="formZoom" class="float-right">
            <form-slider id="iconZoom" v-on:form-slider-changed="setScale"></form-slider>
            <!-- <span class="zoomLevel">Zoom Level: {{ $store.state.pageScale }}</span> -->
          </div>
          <tooltip-icons v-if="tooltipZoom == true"
            :descriptionIcons="descriptionZoom"
            :left="leftIconZoom"
          />

          <div class="form-group select-group">
            <label class="mb-1">Current Template</label>
            <select id="currentTemplate" style="height:23px;font-size:10pt;padding:0;" class="form-control template-select" v-model="currentTemplateName" @change="changeTemplate">
              <option v-for="(template, index) in $store.state.templates" :key="index">
                {{ template.name }}
              </option>
            </select>
          </div>

          <!-- <span class="last-saved">Last saved {{ lastSaved }}</span> -->
        </div>
      </div>

      <input type="file" accept=".json" ref="importedModels" id="uploadModels" @change="handleModels" hidden/>
      <input type="file" accept=".json" ref="importedDataFields" id="uploadDataFields" @change="handleDataFields" hidden/>
      <input type="file" accept=".json" ref="importedDataMerge" id="uploadDataMerge" @change="handleDataMerge" hidden/>

      <!-- <li>
        <button tabindex="-1" class="btn btn-default" @click="toggleFieldEdit">
          <span v-if="$store.state.editingFields">Disable Field Edit</span>
          <span v-else>Enable Field Edit</span>
        </button>
      </li> -->

      <!-- <div id="modeDisplay">
        <p v-if="$store.state.drawingAnnotation && $store.state.showAnnotations">Annotation Mode</p>
        <p v-else-if="$store.state.dragIndex">Drag Index Mode</p>
        <p v-else-if="$store.state.editingFields">Field Edit Mode</p>
        <p v-else>Autofill Mode</p>
      </div> -->
    </nav>

    <barcode-template-modal
      v-if="isBarcode === true"
      @close="isBarcode = false"
    />

    <global-modal
      v-if="isModal === true"
      :width="90"
    >

      <template slot="header">

        <b>Update Fields</b>

      </template>

      <template slot="body">

        <div
          v-if="isMessageNoMatchForm === false"
          id="changesMerge"
          class="row"
        >
          <div class="col-md-4">
            
            <div class="text-center text-success" style="margin-bottom:15px;">
              <span>
                <i class="fas fa-plus-square"></i>

                <b>Add {{ newFields.length }} fields</b> 
              </span>
            </div>

            <span style="font-size: 1.2em; color: green;">

              <div style="overflow:auto;height:180px;">

                <div v-for="(newField, indexNew) in newFields" :key="indexNew">
                  <small style="display:block ruby;"><b>{{newField.fieldPage}}</b> | {{newField.name}}</small>
                </div>

              </div>
            </span>
          </div>

          <div class="col-md-4">

            <div class="text-center text-danger" style="margin-bottom:15px;">
              <span>
                <i class="fas fa-minus-square"></i>

                <b>Delete {{ oldFields.length }} fields</b>
              </span>
            </div>

            <span style="font-size: 1.2em; color: Tomato;">

              <div style="overflow:auto;height:180px;">

                <div v-for="(oldField, indexOld) in oldFields" :key="indexOld">
                  <small style="display:block ruby;"><b>{{oldField.fieldPage}}</b> | {{oldField.id}}</small>
                </div>

              </div>
            </span>
          </div>

          <div class="col-md-4">
           
            <div class="text-center text-primary" style="margin-bottom:15px;">
              <span>
                <i class="fas fa-exchange-alt"></i>

                <b>Modify {{ vPropFields.length }} fields</b>
              </span>
            </div>

            <span style="font-size: 1.2em; color: Mediumslateblue;">

              <div style="overflow:auto;height:180px;">

                <div v-for="(vPropField, indexMod) in vPropFields" :key="indexMod">
                  <small style="display:block ruby;"><b>{{vPropField.fieldPage}}</b> | {{vPropField.name}}</small>
                </div>

              </div>
            </span>
          </div>
        </div>

        <div v-if="isMessageNoMatchForm === true">
          <p class="mb-0" style="color:red;">Number of pages do not match.</p>
        </div>

      </template>

      <template slot="footer" class="ssss">

        <div style="margin-bottom:10px;">
          <button
            class="btn btn-secondary"
            @click="isModal = false"
          >
            Cancel
          </button>

          <button
            :disabled="isDisableBtnMerge || (newFields.length === 0 && oldFields.length === 0 && vPropFields.length === 0)"
            class="btn btn-success"
            @click="mergeData"
          >
            Merge
          </button>
        </div>

        <small style="color: red;position: absolute;margin-top: 32px;">The deleted fields, also will be removed in questionnaire</small>

      </template>
    </global-modal>
  </div>
</template>

<script>
  import FormSlider from '@/components/editor/inputs/FormSlider'
  import RestoredFieldsModal from '@/components/editor/modals/RestoredFieldsModal'
  import TooltipIcons from '@/components/editor/main/TooltipIcons'
  import BarcodeTemplateModal from '@/components/editor/modals/BarcodeTemplateModal.vue'
  import GlobalModal from '@/components/editor/modals/GlobalModal.vue'

  export default {
    name: 'menu-top',

    components: {
      FormSlider,
      RestoredFieldsModal,
      TooltipIcons,
      BarcodeTemplateModal,
      GlobalModal
    },

    data () {
      return {
        scale: '1',
        lastSaved: '',
        currentTemplateName: '',
        modelDisplay: false,
        idDisplay: false,
        tooltipReturnList: false,
        descriptionReturnList: 'Return To Form List',
        leftIconReturnList: 0,
        tooltipShowHide: false,
        descriptionShowHide: 'Tab Indexes or Inputs',
        leftIconShowHide: 0,
        tooltipDragIndex: false,
        descriptionDragIndex: 'Drag Index',
        leftIconDragIndex: 0,
        tooltipResetTabIndexes: false,
        descriptionResetTabIndexes: 'Reset Tab Indexes',
        leftIconResetTabIndexes: 0,
        tooltipCreateField: false,
        descriptionCreateField: 'Create Field',
        leftIconCreateField: 0,
        tooltipSaveTemplate: false,
        descriptionSaveTemplate: 'Save Template Data',
        leftIconSaveTemplate: 0,
        tooltipMultipleSelect: false,
        descriptionMultipleSelect: 'Multiple Select',
        leftIconMultipleSelect: 0,
        tooltipImportModels: false,
        descriptionImportModels: 'Import Models',
        leftIconImportModels: 0,
        tooltipImportAllTranslations: false,
        descriptionImportAllTranslations: 'Import All Translations From Model',
        leftIconImportAllTranslations: 0,
        tooltipRestoreFields: false,
        descriptionRestoreFields: 'Restore Fields',
        leftIconRestoreFields: 0,
        tooltipHighlighter: false,
        descriptionHighlighter: 'Models or Id Fields',
        leftIconHighlighter: 0,
        tooltipBarcodeTemplate: false,
        descriptionBarcodeTemplate: 'Barcode template',
        leftIconBarcodeTemplate: 0,
        tooltipMergeData: false,
        descriptionMergeData: 'Import Data',
        leftIconMergeData: 0,
        tooltipZoom: false,
        descriptionZoom: 'Zoom',
        leftIconZoom: 0,

        isBarcode: false,
        isModal: false,
        isDisableBtnMerge: false,

        newFields: [],
        oldFields: [],
        vPropFields: [],
        isMessageNoMatchForm: false
      }
    },

    mounted () {
      this.$bus.on('saveAll', this.calculateLastSaved)
      setInterval(this.calculateLastSaved, 10000)
      this.$store.commit('setLastSaved', Date.now())
      this.calculateLastSaved()
      this.currentTemplateName = this.$store.state.currentTemplateName
      let that = this
      this.$bus.on('setCurrentTemplateName', function (templateName) {
        that.currentTemplateName = templateName
      })

      this.leftIconReturnList = document.getElementById('iconReturnList').offsetLeft
      this.leftIconShowHide = document.getElementById('iconShowHide').offsetLeft
      if (document.getElementById('iconDisableDragIndex') != null) this.leftIconDragIndex = document.getElementById('iconDisableDragIndex').offsetLeft
      if (document.getElementById('iconEnableDragIndex') != null) this.leftIconDragIndex = document.getElementById('iconEnableDragIndex').offsetLeft
      this.leftIconResetTabIndexes = document.getElementById('iconResetTabIndexes').offsetLeft
      this.leftIconCreateField = document.getElementById('iconCreateField').offsetLeft
      this.leftIconSaveTemplate = document.getElementById('iconSaveTemplate').offsetLeft
      if (document.getElementById('iconDisableMS') != null) this.leftIconMultipleSelect = document.getElementById('iconDisableMS').offsetLeft
      if (document.getElementById('iconEnableMS') != null) this.leftIconMultipleSelect = document.getElementById('iconEnableMS').offsetLeft
      this.leftIconImportModels = document.getElementById('iconImportModels').offsetLeft
      this.leftIconImportAllTranslations = document.getElementById('iconImportAllTranslations').offsetLeft
      this.leftIconRestoreFields = document.getElementById('iconRestoreFields').offsetLeft
      this.leftIconHighlighter = document.getElementById('iconHighlighter').offsetLeft
      this.leftIconBarcodeTemplate = document.getElementById('iconBarcodeTemplate').offsetLeft
      this.leftIconMergeData = document.getElementById('iconMergeData').offsetLeft
      this.leftIconZoom = document.getElementById('iconZoom').offsetLeft
    },

    methods: {
      goToList () {
        this.$bus.emit('showList')
      },

      toggleModelDisplay () {
        this.modelDisplay = !this.modelDisplay
        this.$bus.emit('toggleModelDisplay', this.modelDisplay)
      },

      toggleIdDisplay () {
        this.idDisplay = !this.idDisplay
        this.$bus.emit('toggleIdDisplay', this.idDisplay)
      },

      importAllTranslationModel () {
        let newLabel = ''
        let newText = ''

        const apiUrl = this.$store.state.apiUrl
        this.axios.get(apiUrl + 'model/list').then(response => {
          this.$store.commit('setModels', response.data)
        })

        let dataFields = this.$store.getters.getAllModels()

        if (dataFields.length === 0) return

        dataFields.forEach((field) => {
          const foundModel = JSON.parse(JSON.stringify(this.$store.getters.searchModels(field.model)))
          if (typeof foundModel._id === 'undefined') return
          if (typeof foundModel.label === 'undefined' || !foundModel.label.length) {
            newLabel = field.name
            newText = field.name
          } else {
            newLabel = foundModel.label
            newText = foundModel.desc
          }

          const templateField = JSON.parse(JSON.stringify(this.$store.getters.currentTemplateField(field.name)))
          if (templateField.questionHelp && templateField.questionHelp !== undefined && templateField.questionHelp !== null && templateField.questionHelp !== '') newText = templateField.questionHelp

          let translation = {}
          translation.en = {
            label: newLabel,
            text: newText
          }
          this.$store.commit('setTranslationForId', {
            translation: translation,
            field: field
          })
        })
        this.$store.dispatch('saveTemplatePages')
        this.$bus.emit('updateQuestionnaire')
        this.$bus.emit('setQuestionnairesFields')
      },

      importModels: function () {
        document.getElementById('uploadModels').click()
      },

      handleModels () {
        const files = this.$refs.importedModels.files

        if (files.length === 0) return false

        let fr = new FileReader()
        fr.readAsText(files.item(0))

        let that = this
        fr.onload = function (e) {
          let models = JSON.parse(e.target.result)
          if (models.length === 0) return

          that.deleteOldAutofillDetails(models)
        }
      },

      deleteOldAutofillDetails (models) {
        let state = this.$store.state

        this.$store.dispatch('deleteAutofillDetails', {
          autofillId: state.autofillId,
          templateId: state.templates[this.$store.state.currentTemplateName]._id
        }).then(response => {
          if (response.data.success === true) {
            this.$store.dispatch('getAutofillDetails', this.$store.state.autofillId).then(() => {
              this.getAutofillDetailsValue(models)
            })
          }
        })
      },

      getAutofillDetailsValue (models) {
        let autofillDetailsValue = this.$store.state.autofillDetails.filter(a => a.value !== '')

        autofillDetailsValue.forEach(autofillDetailValue => {
          if (models.map(a => a.pdf_field).indexOf(autofillDetailValue.pdfField) !== -1) {
            this.deleteOneAutofillDetail(autofillDetailValue)
          }
        })

        this.saveModelAutofillDetail(models)
      },

      deleteOneAutofillDetail (autofillDetail) {
        this.$store.dispatch('deleteAutofillDetail', {
          autofillDetailId: autofillDetail._id
        }).then(response => response)
      },

      saveModelAutofillDetail (models) {
        let arrayAutofillDetails = []
        let state = this.$store.state

        let templatePages = state.templates[state.currentTemplateName]['pages']
        let questionnaireFields = state.questionnaires[state.currentTemplateName]['data']

        models.forEach((model, indexModel) => {
          let modelReplace = model.pdf_field.replace(/\./g, '_')

          const autofillDetail = {
            autofillId: this.$store.state.autofillId,
            templateId: this.$store.state.templates[this.$store.state.currentTemplateName]._id,
            value: '',
            createdAt: new Date(),
            updatedAt: new Date()
          }

          // COMPARE TEMPLATE

          Object.keys(templatePages).forEach(pageId => {
            if (templatePages[pageId] === null) return

            if (templatePages[pageId].map(a => a.id).indexOf(modelReplace) !== -1) {
              autofillDetail.fieldType = templatePages[pageId][templatePages[pageId].map(a => a.id).indexOf(modelReplace)].type
            }
          })

          // COMPARE AUTOFILL DETAILS LIST

          autofillDetail.pdfField = model.pdf_field
          autofillDetail.model = model.model

          arrayAutofillDetails.push(autofillDetail)

          Object.keys(questionnaireFields).forEach(fieldId => {
            if (questionnaireFields[fieldId].fieldName === modelReplace) {
              questionnaireFields[fieldId].model = model.model
            }
          })

          // INSERT MANY AUTOFILLDETAILS

          if ((indexModel + 1) === models.length) {
            this.$store.dispatch('addAutofillDetail', arrayAutofillDetails).then(response => {
              if (response.data.success === true) {
                this.refreshAutofillModels()

                this.$store.commit('setQuestionnaireFields', questionnaireFields)
                this.$bus.emit('updateQuestionnaire')
              } else {
                window.vueBus.emit('addNotification', {
                  title: 'Import models',
                  body: 'No import models.',
                  type: 'error'
                })
              }
            })
          }
        })
      },

      refreshAutofillModels () {
        this.$bus.emit('hideEditorFields')
        this.$store.dispatch('getAutofillDetails', this.$store.state.autofillId).then(() => {
          this.$store.commit('setModelsAutofillDetails')

          this.$bus.emit('hidePageFields')

          window.vueBus.emit('addNotification', {
            title: 'Import models',
            body: 'Succesfully.!',
            type: 'success'
          })
        })
      },

      restoreFieldsDataJson: function () {
        document.getElementById('uploadDataFields').click()
      },

      handleDataFields () {
        const files = this.$refs.importedDataFields.files

        if (files.length === 0) return false

        let fr = new FileReader()
        fr.readAsText(files.item(0))

        let that = this
        fr.onload = function (e) {
          let objectFile = JSON.parse(e.target.result)
          let fileName = objectFile.filename.split('.')[0]

          let formName = that.$store.state.outputPath.split('/')[4]

          if (fileName === formName) {
            let nameFields = that.$store.getters.getAllFieldNamesFromTemplate()
            let pages = objectFile.pages
            let templates = that.$store.state.templates
            let restoredFields = []

            Object.keys(pages).forEach(pageId => {
              Object.keys(pages[pageId].pageFields).forEach(fieldId => {
                if (nameFields.indexOf(fieldId) === -1) {
                  let field = pages[pageId].pageFields[fieldId]

                  let newData = {
                    fieldPage: pageId,
                    id: fieldId,
                    name: fieldId,
                    model: '',
                    value: '',
                    type: field.fieldType,
                    tabOrder: field.tabOrder,
                    x: field.x,
                    y: field.y,
                    width: field.width,
                    height: field.height,
                    maskType: '',
                    translations: {}
                  }

                  if (typeof field.choiceData !== 'undefined' && typeof field.choiceData === 'string') {
                    newData['choiceData'] = field.choiceData.slice(1, -1).split(',')
                  }

                  templates[that.$store.state.currentTemplateName].pages[pageId].push(newData)

                  restoredFields.push(newData)
                }
              })
            })

            if (restoredFields.length > 0) {
              that.$store.commit('setTemplates', templates)
            }

            that.$bus.$emit('showRestoredFieldsModal', restoredFields)
            that.$store.dispatch('saveTemplatePages')
            that.$store.commit('setCurrentTemplateName', 'global')
            that.$store.commit('setCurrentTemplateName', 'default')
          } else {
            that.$bus.$emit('showRestoredFieldsModal', {
              isNotFileName: true
            })
          }
        }
      },

      mergeFieldsData: function () {
        document.getElementById('uploadDataMerge').click()
      },

      handleDataMerge () {
        const files = this.$refs.importedDataMerge.files

        if (files.length === 0) return false

        let fr = new FileReader()
        fr.readAsText(files.item(0))

        let that = this

        fr.onload = function (e) {
          let objectFile = JSON.parse(e.target.result)

          that.newFields = []
          that.oldFields = []
          that.vPropFields = []

          that.compareChangesData({
            newData: objectFile
          })

          that.isModal = true
          that.isDisableBtnMerge = false
        }
      },

      addField () {
        this.$store.commit('addField')
        this.$bus.emit('hidePageFields')
        this.$store.dispatch('saveTemplate')
      },

      changeTemplate () {
        this.$store.commit('setCurrentTemplateName', this.currentTemplateName)
        this.$bus.emit('setCurrentTemplateName', this.currentTemplateName)
        let that = this
        this.$store.dispatch('applyTemplate').then(function (result) {
          if (result) {
            that.$bus.emit('addNotification', {
              title: 'Applied Template',
              body: 'Template "' + that.currentTemplateName + '" applied successfully.',
              type: 'success'
            })
          } else {
            that.$bus.emit('addNotification', {
              title: 'Error Applying Template',
              body: 'An error occured while applying the template "' + that.currentTemplateName + '". Please review the data and try again.',
              type: 'error'
            })
          }
        })
      },

      toggleFieldEdit () {
        if (this.$store.state.editingFields) {
          this.$store.commit('setShowAnnotationMenu', false)
          this.$store.commit('setDrawAnnotations', false)
          this.$store.commit('setShowBottomMenu', true)
          this.$store.commit('setFieldEditMode', false)
        } else {
          this.$store.commit('setShowAnnotationMenu', false)
          this.$store.commit('setDrawAnnotations', false)
          this.$store.commit('setShowBottomMenu', false)
          this.$bus.emit('hideControls')
          this.$store.commit('setFieldEditMode', true)
        }
      },

      calculateLastSaved () {
        this.lastSaved = window.moment(this.$store.state.lastSaved).fromNow()
      },

      saveData () {
        this.$store.dispatch('saveTemplate')
      },

      toggleAssignIndexes () {
        this.$store.commit('toggleAssigningIndexes')
      },

      toggleDragIndex () {
        this.$store.commit('toggleDragIndex')
      },

      multipleSelect () {
        this.$store.commit('toggleMultipleSelect')
      },

      setScale (val) {
        this.$bus.$emit('setPageScale', Number(val))
        this.$store.commit('setPageScale', Number(val))
      },

      toggleShowFields () {
        this.$store.commit('toggleShowFields')
      },

      resetIndexes () {
        this.$bus.$emit('showDialog', {
          title: 'Reset All Tab Indexes?',
          desc: 'This action will erase all tab indexes on the current page. Do you want to continue?',
          confirmAction: 'resetTabOrders'
        })
      },

      compareChangesData (payload) {
        let oldData = this.$store.state.templates[this.$store.state.currentTemplateName]

        let existNewField = false
        let existOldField = false

        if (Object.keys(payload.newData.pages).length !== Object.keys(oldData.pages).length) {
          this.isMessageNoMatchForm = true

          return
        }

        // FIND NEW FIELDS

        for (let indexData = 1; indexData <= Object.keys(oldData.pages).length; indexData++) {
          Object.keys(payload.newData.pages[indexData].pageFields).forEach(fieldKey => {
            let newPage = payload.newData.pages[indexData].pageFields
            existNewField = false

            if (oldData.pages[indexData].map(a => a.id).indexOf(fieldKey) !== -1) existNewField = true

            if (existNewField === false) {
              newPage[fieldKey].fieldPage = indexData

              this.newFields.push(newPage[fieldKey])
            }
          })
        }

        // FIND OLD FIELDS
        console.log(Object.keys(oldData.pages).length)

        for (let indexData = 1; indexData <= Object.keys(oldData.pages).length; indexData++) {
          oldData.pages[indexData].forEach(oldField => {
            existOldField = false

            if (Object.keys(payload.newData.pages[indexData].pageFields).indexOf(oldField.id) !== -1) existOldField = true

            // FIND CHANGE ON VIEW PROPERTIES

            Object.values(payload.newData.pages[indexData].pageFields).forEach(newField => {
              if (oldField.id === newField.name) {
                if (
                  oldField.x !== newField.x ||
                  oldField.y !== newField.y ||
                  oldField.height !== newField.height ||
                  oldField.width !== newField.width ||
                  oldField.type.toLowerCase() !== newField.fieldType.toLowerCase()
                ) {
                  newField.fieldPage = oldField.fieldPage

                  this.vPropFields.push(newField)
                }
              }
            })

            if (existOldField === false) this.oldFields.push(oldField)
          })
        }
      },

      mergeData () {
        this.isDisableBtnMerge = true

        let templates = JSON.parse(JSON.stringify(this.$store.state.templates))

        let oldData = templates[this.$store.state.currentTemplateName]

        // MERGE NEW FIELDS

        this.newFields.forEach(newField => {
          let newData = {
            id: newField.name,
            name: newField.name,
            model: '',
            value: '',
            fieldPage: newField.fieldPage,
            type: newField.fieldType.toLowerCase(),
            tabOrder: newField.tabOrder,
            x: newField.x,
            y: newField.y,
            width: newField.width,
            height: newField.height,
            maskType: '',
            translations: {
              en: {
                label: newField.name,
                text: newField.name
              }
            }
          }

          if (typeof newField.choiceData !== 'undefined' && typeof newField.choiceData === 'string') {
            newData['choiceData'] = newField.choiceData.slice(1, -1).split(',')
          }

          oldData.pages[newData.fieldPage].push(newData)
        })

        // DELETE OLD FIELDS

        this.oldFields.forEach(oldField => {
          oldData.pages[String(oldField.fieldPage)].forEach((field, indexField) => {
            if (oldField.id === field.id) oldData.pages[oldField.fieldPage].splice(indexField, 1)
          })
        })

        // MERGE VIEW PROPERTIES

        this.vPropFields.forEach(vPropField => {
          oldData.pages[String(vPropField.fieldPage)].forEach((field, indexField) => {
            if (vPropField.name === field.id) {
              field.x = vPropField.x
              field.y = vPropField.y
              field.height = vPropField.height
              field.width = vPropField.width
              field.type = vPropField.fieldType
            }
          })
        })

        templates[this.$store.state.currentTemplateName] = oldData

        this.$store.commit('setTemplates', templates)

        this.$store.dispatch('saveTemplatePages')

        this.isModal = false

        this.$bus.emit('hidePageFields')

        this.deleteFieldsQuestionnaire()
      },

      deleteFieldsQuestionnaire () {
        let questionnaires = JSON.parse(JSON.stringify(this.$store.state.questionnaires))

        let currentFieldsQuestionnaire = questionnaires[this.$store.state.currentTemplateName].data

        Object.keys(currentFieldsQuestionnaire).forEach(fieldQKey => {
          if (this.oldFields.map(a => a.id).indexOf(currentFieldsQuestionnaire[fieldQKey].fieldName) !== -1) {
            delete currentFieldsQuestionnaire[fieldQKey]
          }
        })

        questionnaires[this.$store.state.currentTemplateName].data = currentFieldsQuestionnaire

        this.$store.commit('setQuestionnaires', questionnaires)

        this.$bus.emit('updateQuestionnaire')

        this.$bus.emit('reloadQuestionnaire')
      }
    },

    beforeDestroy () {
      this.$bus.$off('saveAll')
      this.$bus.$off('setCurrentTemplateName')

      this.$store.commit('setAutofillDetails', null)
      this.$store.commit('setAutofillId', null)
    }
  }
</script>

<style lang="scss" scoped>
  .bar-icons{
    position: fixed;
    width: 49%;
    background-color: #e5e4e4;
    box-shadow: 5px 4px 9px -3px rgba(0,0,0,0.8);
    left: 1%;
    padding-bottom: 10px;
    z-index: 5;
    top: 0;
    background-color: #ececec;
    box-shadow: 1px 2px 8px -3px rgba(0, 0, 0, 0.8);
  }
  .icons-individual{
    display: inline;
    margin-right: -6px;
  }
  .iconsall{
      margin-left: 6px;
  }
  .mybutton{
    background-color: white;
    margin: 10px 3px 0px 4px;
    // border: 1px solid black;
    font-size: .830rem;
    border: 1px solid rgba(0, 0, 0, 0.46);
    border-radius: 0.25rem;
  }
  .mybutton:hover{
      background-color: lightgray;
  }
  .colorIcon01 {
    color: #00e4ff;
  }
  .colorIcon02 {
    color: #05e0c3;
  }
  .backgroundIcon {
    background-color: #05e0c3;
  }
  .zoomLevel {
    width: 100px;
    display: block;
    font-size: 8.5pt;
  }



  #formZoom {
    // position: absolute;
    // top: 55px;
    padding-right: 15px;
    padding-top: 17px;
    // width: 120%;
    color: black;
    display: inline !important;
    // background-color: white;
    // border-radius: 6px;
    // left: 50%;
    // transform: translateX(-50%);
    text-align: center;
  }

  #topNav {
    user-select: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 50%;
    height: 50px;
    display: block;
    box-sizing: border-box;
    z-index: 100;
    color: #FFF;

    .navbar {
      background-color: #2D5F8B;
      border: none;
      border-radius: 0;
      margin: 0;
    }
  }

  #uploadModels {
    margin-top: -200px;
  }

  #modeDisplay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    color: #FFF;
    font-size: 18px;
    font-weight: bold;
    width: 200px;
    height: 30px;
    z-index: 1050;
    background-color: #2d5f8b;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .topControls {
    display: inline-block;
    margin-left: 10px;

    li {
      margin: 5px 3px;
      button {
        margin-top: 5px;
        font-size: 70%;
        border-style: hidden;
        transition: .3s;
        &:hover {
          background-color: #333;
          color: white;
          transition: .3s;
        }
      }
    }
  }

  .last-saved, .select-group {
    position: absolute;
    top: 15px;
    right: 400px;
    font-size: 15px;
  }

  .select-group {
    top: -4px;
    right: -98%;
    text-align: center;

    label {
      font-weight: bold;
      font-size: 70%;
    }
  }

  .template-select {
    margin-left: 2%;
    width: 95%;
    display: block;
  }

  .navbar-brand {
    padding: 5px 5px;
    color: #FFF !important;
    margin: 0;
    cursor: default;
    &:focus {
      outline: none;
    }

    img {
      width: 140px;
      height: auto;
      // float: left;
      margin-top: 6px;
    }

    span {
      padding: 10px 10px;
      // float: left;
      font-family: "Open Sans", sans-serif;
      font-weight: 300;
      line-height: 1.1em;
      font-size: 80%;
    }

    &:after {
      clear: both;
    }
  }

  .dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative; }

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent; }

.dropdown-toggle:empty::after {
  margin-left: 0; }

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem; }

.dropdown-menu-right {
  right: 0;
  left: auto; }

@media (min-width: 576px) {
  .dropdown-menu-sm-right {
    right: 0;
    left: auto; } }

@media (min-width: 768px) {
  .dropdown-menu-md-right {
    right: 0;
    left: auto; } }

@media (min-width: 992px) {
  .dropdown-menu-lg-right {
    right: 0;
    left: auto; } }

@media (min-width: 1200px) {
  .dropdown-menu-xl-right {
    right: 0;
    left: auto; } }

.dropdown-menu-left {
  right: auto;
  left: 0; }

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0; } }

@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0; } }

@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0; } }

@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0; } }

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem; }

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent; }

.dropup .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem; }

.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid; }

.dropright .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropright .dropdown-toggle::after {
  vertical-align: 0; }

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem; }

.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: ""; }

.dropleft .dropdown-toggle::after {
  display: none; }

.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent; }

.dropleft .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropleft .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-menu[x-placement^="top"], .dropdown-menu[x-placement^="right"], .dropdown-menu[x-placement^="bottom"], .dropdown-menu[x-placement^="left"] {
  right: auto;
  bottom: auto; }

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef; }

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0; }
  .dropdown-item:hover, .dropdown-item:focus {
    color: #16181b;
    text-decoration: none;
    background-color: #f8f9fa; }
  .dropdown-item.active, .dropdown-item:active {
    color: #fff;
    text-decoration: none;
    background-color: #007bff; }
  .dropdown-item.disabled, .dropdown-item:disabled {
    color: #6c757d;
    pointer-events: none;
    background-color: transparent; }

.dropdown-menu.show {
  display: block;
  top: -28px !important }

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap; }

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529; }
</style>



// WEBPACK FOOTER //
// src/components/editor/main/MenuTop.vue